export default (initialState = {}) => ({
	accordion: initialState.accordion || [],
	submitting: false,
	updateAccordions(element) {
		const indexOfElement = this.accordion.indexOf(element);

		if (indexOfElement !== -1) {
			this.accordion.splice(indexOfElement, 1);
		} else {
			this.accordion.push(element);
		}
	}
})
